"use client";
import React,{useState} from 'react'
import { ProductProvider } from '../components/Productcontext'
import Producthomecontent from '../components/Producthomecontent'
import Footer from '../components/Footer'
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';
import EarthinCategoryContent from '../components/EarthingCategoryContent';
import InstallationBanner from '../components/InstallationBanner';
import ProductsubMenu from '../components/ProductsubMenu';
import ele_banner1 from '../images/lightningcategory/earthing-category-banner.jpg';
import ele_banner1_360 from '../images/lightningcategory/earthing-category-banner_360.jpg';
import ele_banner1_tab from '../images/lightningcategory/earthing-category-banner_tab.jpg';
import ele_banner1_2x from  '../images/lightningcategory/earthing-category-banner@2x.jpg';


const EarthingCategoryPage = () => {
    return (
      <div>
           <ProductProvider>
          {/* <PreHeader/>
          <Header/>    
           <Menu/> */}
           <InstallationBanner page="installation" banalt="ASEEL chemical earthing electrode — maintenance-free, IS 3043 compliant" apostropheBefore="" apostropheAfter="" ban1x={ele_banner1} ban2x={ele_banner1_2x} ban360={ele_banner1_360} bantab={ele_banner1_tab} />
           <ProductsubMenu/>
          <EarthinCategoryContent/>
           
           <Footer/>
           </ProductProvider>
      </div>
    )
  }
  
  export default EarthingCategoryPage
 
